import Vue from 'vue'
import appDataset from '@/plugins/appDataset'

let tenant = {}
tenant.tenant = appDataset.tenant
tenant.title = appDataset.title ? appDataset.title : 'eSpocial'
tenant.title_sup = appDataset.title_sup
tenant.footer = {}
tenant.footer.text = appDataset.footer_text ? appDataset.footer_text : '© 2020 by Thomas Kirschner'
tenant.headerLogo = appDataset.commonAppAssetsBaseUrl + '/' + (appDataset.headerLogo ? appDataset.headerLogo : 'assets/default/logo.svg')
tenant.mainLogo = appDataset.commonAppAssetsBaseUrl + '/' + (appDataset.mainLogo ? appDataset.mainLogo : 'assets/default/logo-large.svg')
tenant.advertising = {}
tenant.advertising.type = (appDataset.advertisingType ? appDataset.advertisingType : 'default');
tenant.home = {}
tenant.home.content = (appDataset.homeContent ? appDataset.homeContent : 'featureSlider')

Vue.prototype.$tenant = tenant
export default Vue.prototype.$tenant
